import { useState } from 'react';

import { Link } from 'react-router-dom';
import * as Yup from 'yup';

import { Form, Password, Text } from '../../../Components/Form';
import { useAuth } from '../../../Hooks/Auth';
import Logo from '../Assets/Images/logo.png';

const validationSchema = Yup.object({
  national_card_id: Yup.string()
    .required('کد ملی الزامی است')
    .min(10, 'کد ملی باید 10 رقم باشد')
    .max(10, 'کد ملی باید 10 رقم باشد'),
  password: Yup.string()
    .required('کلمه عبور الزامی است')
    .min(8, 'کلمه عبور باید حداقل 8 رقم باشد.'),
});

const Login = () => {
  const { login, check } = useAuth();
  const [serverErrors, setServerErrors] = useState({});
  const [loading, setLoading] = useState();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <section className='login-page'>
        <div className='container' style={{ paddingTop: '70px' }}>
          <div className='shadow-lg rounded-2' style={{ height: '650px' }}>
            <Form
              initialValues={{
                national_card_id: '',
                password: '',
              }}
              validationSchema={validationSchema}
              defaultActions={false}
              onSubmit={(values) =>
                login(values, setLoading, setServerErrors, serverErrors)
              }
            >
              <div className='row w-100 m-0'>
                <div className='col-12 col-md-6'>
                  <div
                    className='d-flex flex-column '
                    style={{ height: '100%' }}
                  >
                    <div className='my-5 d-flex flex-row justify-content-center align-items-cenetr'>
                      <img src={Logo} alt='logo' className='w-50' />
                    </div>
                    <h1 className='text-dark  f-16 mb-5 font-weight-bold text-center'>
                      سامانه مسابقات فدراسیون ورزش های زورخانه ای
                    </h1>
                    <p
                      className='f-14 text-dark text-left'
                      style={{ lineHeight: '30px' }}
                    >
                      توجه : قبل از ورود به سامانه مسابقات باید در سامانه آموزش
                      با آدرس
                      <a
                        href='https://portal.izpf.ir'
                        className='text-info f-16 font-weight-bold mx-2'
                      >
                        portal.izpf.ir
                      </a>
                      ثبت نام کرده و با نام کاربری و کلمه عبور سامانه آموزش به
                      سامانه مسابقات وارد شوید.
                    </p>
                    <h2 className='text-dark f-16 my-3 font-weight-bold'>
                      لینک ها :{' '}
                    </h2>
                    <ul className='d-flex flex-column'>
                      <li className='my-2'>
                        <a
                          className='f-14 text-danger'
                          href='https://portal.izpf.ir'
                        >
                          - ثبت نام در سامانه آموزش
                        </a>
                      </li>
                      <li className='my-2'>
                        <Link className='f-14 text-danger' to='/gym/list'>
                          - لیست زورخانه ها
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link className='f-14 text-danger' to='/gym/create'>
                          - ثبت زورخانه
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='col-12 col-md-6'>
                  <div className='row bg-white rounded-2 mt-md-5 shadow mx-3 pt-5'>
                    <div className='col-12'>
                      <div className='d-flex flex-row justify-content-between align-items-center'>
                        <span className='h-line-2 w-30'></span>
                        <h1 className='text-dark-blue mx-2 f-16 font-weight-bold'>
                          ورود به سامانه
                        </h1>
                        <span className='h-line-2 w-30'></span>
                      </div>
                    </div>
                    <div className='col-12 mt-3'>
                      <h2 className='text-dark-blue f-14 line-height-3'>
                        برای ورود به سامانه مسابقات ورزش های زورخانه ای اطلاعات
                        ورود خود را وارد و بر روی دکمه ورود کلیک کنید.
                      </h2>
                    </div>
                    <div className='col-12 mt-3'>
                      <div
                        className='w-100 d-flex flex-row align-items-center justify-content-center bg-blue-sky border rounded-1 my-3 position-relative'
                        style={{ height: '40px' }}
                      >
                        <Text
                          name='national_card_id'
                          containerClass='w-90 h-100 p-0 m-0 form-group-pos'
                          title='کد ملی'
                          className='bg-none border-0 rounded-1 m-0 p-0'
                          serverError={serverErrors?.national_card_id}
                        />
                        <div
                          className='d-flex flex-column align-items-center justify-content-center w-10 bg-blue-sky-dark rounded-1 h-100 mt-3 border'
                          style={{
                            position: 'absolute',
                            top: '-16px',
                            left: '0',
                          }}
                        >
                          <i className='far fa-user f-18'></i>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 mt-3'>
                      <div
                        className='w-100 d-flex flex-row align-items-center justify-content-center bg-blue-sky border rounded-1 my-3 position-relative'
                        style={{ height: '40px' }}
                      >
                        <Password
                          containerClass='w-90 h-100 p-0 m-0 form-group-pos'
                          title='کلمه عبور'
                          className='bg-none border-0 rounded-1 m-0 p-0'
                          name='password'
                          showPassword={showPassword}
                          serverError={serverErrors?.password}
                        />

                        <i
                          className={`fad ${
                            showPassword ? 'fa-eye-slash' : 'fa-eye'
                          } text-dark f-18 c-pointer`}
                          onClick={() =>
                            setShowPassword((preveState) => !preveState)
                          }
                          style={{
                            position: 'absolute',
                            top: '11px',
                            left: '51px',
                          }}
                        ></i>
                        <div className='d-flex flex-row align-items-center justify-content-center w-10 bg-blue-sky-dark rounded-1 h-100 mt-3 border login-icon-input login-icon-input'>
                          <i className='far fa-lock f-18 mx-2'></i>
                        </div>
                      </div>
                    </div>

                    <div className='col-12 my-3'>
                      {loading ? (
                        <button className='btn bg-blue-sky-fill border rounded-1 w-100'>
                          <div
                            className='spinner-border text-white spinner-border-sm mb-1'
                            role='status'
                          >
                            <span className='sr-only'></span>
                          </div>
                        </button>
                      ) : (
                        <button
                          type='submit'
                          className='btn bg-blue-sky-fill border rounded-1 w-100'
                        >
                          <i></i>
                          ورود به سامانه
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
